import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollTop = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    // ✅ SimpleBar scroll (PendingOrder works because of this)
    const simpleBar = document.querySelector(".simplebar-content-wrapper");
    if (simpleBar) {
      simpleBar.scrollTop = 0;
    }

    // ✅ Outstanding table scroll (THIS was missing)
    const outstandingTable = document.getElementById("outstanding-scroll");
    if (outstandingTable) {
      outstandingTable.scrollTop = 0;
    }

    // ✅ fallback
    window.scrollTo(0, 0);
  }, [pathname]);

  return children;
};

export default ScrollTop;
